export default [
    {
        name: 'error',
        path: '/error',
        component: ( ) => import('@/views/error/ErrorView.vue')
    }
]